class AdSortableCanvas {

    constructor($rootScope) {
        
        this.$rootScope = $rootScope;

        let _self = this;

        return {
            restrict: 'A',
            scope: {
            	"adunit": "=adSortableCanvas"
            },
            link: ($scope, $el, $attr) => {
                                
                $el.sortable({
                    items: "> li.canvas-sorter",
                    stop: (ev,ui) => {
                        
                        let canvasOrder = [];
                        
                        $("> li", $el).each( (ix, el) => {
                            let canvasId = $(el).attr("data-canvasid");
                            let canvas = $scope.adunit.canvases.find(x => x.id == canvasId);
                            if(!!canvas) {
                                canvasOrder.push(canvas);
                            }
                        });

                        $scope.adunit.canvases.splice(0);
                        canvasOrder.forEach( (canvas) => {
                            $scope.adunit.canvases.push(canvas);
                        });

                        $scope.$apply();

                    }
                });

			}
		};

	}


}

angular.module('cpm')
    .directive('adSortableCanvas', ['$rootScope', ($rootScope) => {
        'use strict';
        return new AdSortableCanvas($rootScope);
    }]);
